/* MANAGE DAY OFF REQUEST */
Vue.component('pendingclosures', {
    template: '#pendingclosures-template',
    data: function () {
        return {
            moment: moment,
            searchString: '',
            projects_completed: [],
            projects_client_approved: [],
            list_empty: true,
            active_tab: 'client_approved',
            closing_monthly_project: {
                id: null,
                tickets: []
            }
        };
    },
    created: function () {

        activeInstance = this;
        $("#page_title").text('ZÁRÁSOK / ARCHÍVUM (PROJEKTEK ÉS TICKETEK)');
        var id = $('#content_wrapper').attr('data-id');
        activeInstance.getPendingClosures();
        activeInstance.getAcceptedClosures();
    },
    methods: {
        resetClosingMonthlyProject: function () {
            activeInstance.closing_monthly_project = {
                id: null,
                tickets: []
            }
        },
        filterApprovedProjects: function (arr) {
            console.log(1);
            var new_arr = JSON.parse(JSON.stringify(arr));

            var temp_arr = [];

            $.each(new_arr, function (index, project) {
                if (project.phase == 'client_approved') {
                    temp_arr.push(project);
                } else {
                    $.each(project.tickets, function (index, ticket) {
                        if (ticket.phase == 'client_approved') {
                            temp_arr.push(project);
                            return false;
                        }
                    });
                }
            });

            arr = temp_arr;

            console.log(arr);

            this.list_empty = (arr.length == 0);

            return arr;
        },
        confirm: function (record) {
            bootbox.confirm('Biztosan jóváhagyod a ' + record.name + ' zárását?', function (value) {
                if (value == true) {
                    showLoadingOverlay();
                    axios.post(baseURL + '/api/ticket/subscribe/update', {
                        ticket_id: activeInstance.ticket.id,
                        subscribed: !activeInstance.user_is_subscribed
                    })
                        .then(function (response) {
                            activeInstance.user_is_subscribed = response.data.subscribed;
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                }
            });
        },
        reject: function (record) {
            bootbox.confirm('Biztosan elutasítod a ' + record.name + ' zárását?', function (value) {
                if (value == true) {

                    showLoadingOverlay();
                    axios.post(baseURL + '/api/ticket/subscribe/update', {
                        ticket_id: activeInstance.ticket.id,
                        subscribed: !activeInstance.user_is_subscribed
                    })
                        .then(function (response) {
                            activeInstance.user_is_subscribed = response.data.subscribed;
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                }
            });
        },
        getPendingClosures: function () {
            showLoadingOverlay();
            axios.get(baseURL + '/api/ticket/pending_closures').then(function (response) {
                $('body').LoadingOverlay("hide");

                $.each(response.data, function (index, project) {
                    project.details_status = 'open';

                    console.log(project);

                    $.each(project.tickets, function (index, ticket) {
                        ticket.closing = false;
                    });
                });

                activeInstance.projects_client_approved = response.data;
            }).catch(function (error) {
                $('body').LoadingOverlay("hide");
                console.log(error);
            });
        },
        getAcceptedClosures: function () {
            showLoadingOverlay();
            axios.get(baseURL + '/api/ticket/accepted_closures').then(function (response) {


                $.each(response.data, function (index, project) {
                    project.details_status = 'open';
                });

                $('body').LoadingOverlay("hide");

                activeInstance.projects_completed = response.data;
            }).catch(function (error) {
                $('body').LoadingOverlay("hide");
                console.log(error);
            });
        },
        generateUlFromArray: function () {
            var input_array = ['test1', 'test2', 'test3', 'test 4'];
            var full_text = '<ul>';
            $.each(input_array, function (index, value) {
                full_text += '<li>' + value + '</li>';
            });
            full_text += '</ul>';
            return full_text;
        },
        generateTicketMigrationList: function () {
            var full_text = '<ul class="closure_list">';
            $.each(activeInstance.closing_monthly_project.tickets, function (index, ticket) {
                if (ticket.phase != 'completed') {
                    full_text += '<li>' + ticket.name + '</li>';
                }
            });
            full_text += '</ul>';
            return full_text;
        },
        sendMonthlyProjectCloseData: function (project, invoice_number) {
            var closing_tickets = [];

            $.each(project.tickets, function (index, ticket) {
                if (ticket.closing) {
                    closing_tickets.push(ticket.id);
                    ticket.phase = 'completed';
                }
            });

            $('body').LoadingOverlay("show");
            axios.post(baseURL + '/admin/monthly_project/close', {
                'project_id': activeInstance.closing_monthly_project.id,
                'tickets': closing_tickets,
                'invoice_number': invoice_number
            })
                .then(function (response) {
                    $('body').LoadingOverlay("hide");
                    /*
                    $.each(activeInstance.projects_client_approved,function(index,project){
                        if (record.id == project.id) {
                            project.phase = 'completed';
                        }
                    });
                    */
                    vex.dialog.alert('A ' + project.name + ' projekt és ticketei lezárásra kerültek.');
                    activeInstance.getAcceptedClosures();
                    activeInstance.getPendingClosures();
                })
                .catch(function (error, response) {
                    $('body').LoadingOverlay("hide");
                    console.log(error.response.data);

                    //IF WE GOT UNCLOSED TICKETS -> BRING IN THE TICKET MOVING DIALOG
                    if (error.response.data.status == 'unclosed_tickets_present') {
                        vex.dialog.open({
                            input: [
                                /* TITLE */
                                '<h2 style="margin-top:10px;margin-bottom:30px;">' + project.name + '</h2>',
                                '<h4 style="margin-top:10px;margin-bottom:30px;">Fennmaradó ticketek átmozgatása új projektbe</h4>',
                                '<div style="margin-bottom:20px;color:#3aaad8;font-weight:bold;font-size:14px;font-style:italic;">Kérjük add meg az új projekt adatait, amibe a fennmaradó (zárásra nem kijelölt) ticketek kerülnek.</div>',
                                '' + activeInstance.generateTicketMigrationList(),
                                /* PROJECT NAME */
                                '<label style="margin-top:10px;">Az új projekt neve</label>',
                                '<input style="width:100%;display:block;" name="name" type="text" value="' + project.name + ' (másolat)" placeholder="Az új projekt neve" required />',

                                /* DEADLINE */
                                '<fieldset style="margin-top:20px;margin-bottom: 0px;" class="form-group no_padding">',
                                '<label>Ügyfél leadás határideje</label>',
                                '<div class=\'input-group date\' id=\'datetimepicker6\'>',
                                '<input required name="deadline" type=\'text\' class="form-control-vex disabled" id="deadline" />',
                                '<span class="input-group-addon">',
                                '<span class="glyphicon glyphicon-calendar"></span>',
                                '</span>',
                                '</div>',
                                '</fieldset>',

                                /* DATE OF COMPLETION */
                                '<label style="margin-top:20px;">Teljesítés hónapja</label>',
                                '<select name="completion_month" style="margin-bottom:30px;" id="completion_month" required  class="form-control-vex">',
                                '<option value="01">Január</option>',
                                '<option value="02">Február</option>',
                                '<option value="03">Március</option>',
                                '<option value="04">Április</option>',
                                '<option value="05">Május</option>',
                                '<option value="06">Június</option>',
                                '<option value="07">Július</option>',
                                '<option value="08">Augusztus</option>',
                                '<option value="09">Szeptember</option>',
                                '<option value="10">Október</option>',
                                '<option value="11">November</option>',
                                '<option value="12">December</option>',
                                '</select>',
                                ' '
                            ].join(''),
                            buttons: [
                                $.extend({}, vex.dialog.buttons.YES, {text: 'Rendben'}),
                                $.extend({}, vex.dialog.buttons.NO, {text: 'Mégse'})
                            ],
                            afterOpen: function () {
                                setTimeout(function () {
                                    $('#datetimepicker6').datetimepicker({
                                        format: 'YYYY-MM-DD HH:00',
                                        locale: 'hu'
                                    });
                                }, 300);

                            },
                            callback: function (data) {
                                if (!data) {
                                    console.log('Cancelled')
                                }
                                else {
                                    axios.post(baseURL + '/api/project/clone', {
                                        'old_project_id': project.id,
                                        'name': data.name,
                                        'deadline': data.deadline,
                                        'completion_month': data.completion_month
                                    })
                                        .then(function (response) {

                                            //CLOSE TICKETS AND THEN THE PROJECT
                                            activeInstance.sendMonthlyProjectCloseData(project, project.outgoing_invoice_number);
                                            //FETCH THE DATA

                                            activeInstance.getPendingClosures();
                                            activeInstance.getAcceptedClosures();
                                            successNotification('A ' + project.name + ' projekt lezárásra került.');
                                        });
                                }
                            }
                        });
                    }
                    else {
                        activeInstance.sendMonthlyProjectCloseData(project, project.outgoing_invoice_number);
                        activeInstance.getPendingClosures();
                        activeInstance.getAcceptedClosures();
                        successNotification('A ' + project.name + ' projekt lezárásra került.');
                    }


                });


        },
        acceptMonthlyProjectClose: function (project) {

            console.log(project);
            var got_unclosed_tickets = false;
            $.each(project.tickets, function (ticket) {
                if (ticket.phase != 'completed') {

                }
            });

            if (project.invoice_required) {
                vex.dialog.open({
                    input: [
                        /* PROJECT NAME */
                        '<h2 style="margin-top:10px;">A(z) ' + project.name + ' projekt zárása</h2>',
                        '<label style="margin-top:10px;">Kérjük add meg a kimenő számla sorszámát:</label>',
                        '<input style="width:100%;display:block;" name="outgoing_invoice_number" type="text" placeholder="A kimenő számla sorszáma" required />',

                        ' '
                    ].join(''),
                    buttons: [
                        $.extend({}, vex.dialog.buttons.YES, {text: 'Rendben'}),
                        $.extend({}, vex.dialog.buttons.NO, {text: 'Mégse'})
                    ],
                    afterOpen: function () {

                    },
                    callback: function (data) {
                        if (!data) {
                            console.log('Cancelled');
                            return true;
                        }
                        else {
                            activeInstance.sendMonthlyProjectCloseData(project, data.outgoing_invoice_number);
                            project.outgoing_invoice_number = data.outgoing_invoice_number;
                        }
                    }
                });
            }
            else {
                activeInstance.sendMonthlyProjectCloseData(project, null);
            }
        },
        closeProject: function (record) {

            switch (record.billing_type) {

                //####################################
                //##PROJECT BASED#####################
                //####################################
                case 'project_based':
                    bootbox.confirm('Biztosan lezárod a(z) ' + record.name + ' projektet?', function (value) {
                        if (value == true) {

                            if (record.invoice_required) {
                                vex.dialog.open({
                                    input: [
                                        /* PROJECT NAME */
                                        '<h2 style="margin-top:10px;">A(z) ' + record.name + ' projekt zárása</h2>',
                                        '<label style="margin-top:10px;">Kérjük add meg a kimenő számla sorszámát:</label>',
                                        '<input style="width:100%;display:block;" name="outgoing_invoice_number" type="text" placeholder="A kimenő számla sorszáma" required />',

                                        ' '
                                    ].join(''),
                                    buttons: [
                                        $.extend({}, vex.dialog.buttons.YES, {text: 'Rendben'}),
                                        $.extend({}, vex.dialog.buttons.NO, {text: 'Mégse'})
                                    ],
                                    afterOpen: function () {

                                    },
                                    callback: function (data) {
                                        if (!data) {
                                            console.log('Cancelled');
                                            return true;
                                        }
                                        else {
                                            record.outgoing_invoice_number = data.outgoing_invoice_number;

                                            showLoadingOverlay();
                                            axios.post(baseURL + '/admin/project/financially_close', {
                                                'project_id': record.id,
                                                'outgoing_invoice_number': record.outgoing_invoice_number
                                            })
                                            //ON SUCCESS
                                                .then(function (response) {
                                                    $('body').LoadingOverlay("hide");
                                                    $.each(activeInstance.projects_client_approved, function (index, project) {
                                                        if (record.id == project.id) {
                                                            project.phase = 'completed';
                                                        }
                                                    });
                                                    activeInstance.getAcceptedClosures();
                                                    activeInstance.getPendingClosures();
                                                })

                                                //ON ERROR
                                                .catch(function (error, response) {
                                                    $('body').LoadingOverlay("hide");

                                                    if (error.response.data.status == 'unclosed_tickets_present') {
                                                        bootbox.alert("A projektet még nem lehet lezárni, mert nyitott ticketet tartalmaz.");
                                                    } else {
                                                        console.log(error);
                                                    }
                                                });
                                            
                                        }
                                    }
                                });
                            } else {
                                axios.post(baseURL + '/admin/project/financially_close', {
                                    'project_id': record.id
                                })
                                //ON SUCCESS
                                .then(function (response) {
                                    $('body').LoadingOverlay("hide");
                                    $.each(activeInstance.projects_client_approved, function (index, project) {
                                        if (record.id == project.id) {
                                            project.phase = 'completed';
                                        }
                                    });
                                    activeInstance.getAcceptedClosures();
                                    activeInstance.getPendingClosures();
                                })

                                //ON ERROR
                                .catch(function (error, response) {
                                    $('body').LoadingOverlay("hide");

                                    bootbox.alert("Váratlan hiba történt");
                                    console.log(error);
                                });
                            }
                        }
                    });

                    break;

                //####################################
                //##MONTHLY FEE ######################
                //####################################
                case 'monthly_fee':

                    //activeInstance.closing_monthly_project = record;
                    bootbox.confirm('Biztosan lezárod a(z) ' + record.name + ' projektet?', function (value) {

                        if (value == true) {


                            if (record.invoice_required) {
                                vex.dialog.open({
                                    input: [
                                        /* PROJECT NAME */
                                        '<h2 style="margin-top:10px;">A(z) ' + record.name + ' projekt zárása</h2>',
                                        '<label style="margin-top:10px;">Kérjük add meg a kimenő számla sorszámát:</label>',
                                        '<input style="width:100%;display:block;" name="outgoing_invoice_number" type="text" placeholder="A kimenő számla sorszáma" required />',

                                        ' '
                                    ].join(''),
                                    buttons: [
                                        $.extend({}, vex.dialog.buttons.YES, {text: 'Rendben'}),
                                        $.extend({}, vex.dialog.buttons.NO, {text: 'Mégse'})
                                    ],
                                    afterOpen: function () {

                                    },
                                    callback: function (data) {
                                        if (!data) {
                                            console.log('Cancelled');
                                            return true;
                                        }
                                        else {
                                            record.outgoing_invoice_number = data.outgoing_invoice_number;

                                            showLoadingOverlay();
                                            axios.post(baseURL + '/admin/project/financially_close', {
                                                'project_id': record.id,
                                                'outgoing_invoice_number': record.outgoing_invoice_number
                                            })
                                            //ON SUCCESS
                                                .then(function (response) {
                                                    $('body').LoadingOverlay("hide");
                                                    $.each(activeInstance.projects_client_approved, function (index, project) {
                                                        if (record.id == project.id) {
                                                            project.phase = 'completed';
                                                        }
                                                    });
                                                    activeInstance.getAcceptedClosures();
                                                    activeInstance.getPendingClosures();
                                                })

                                                //ON ERROR
                                                .catch(function (error, response) {
                                                    $('body').LoadingOverlay("hide");

                                                    if (error.response.data.status == 'unclosed_tickets_present') {
                                                        bootbox.alert("A projektet még nem lehet lezárni, mert nyitott ticketet tartalmaz.");
                                                    } else {
                                                        console.log(error);
                                                    }
                                                });

                                        }
                                    }
                                });
                            } else {
                                showLoadingOverlay();
                                axios.post(baseURL + '/admin/project/financially_close', {
                                    'project_id': record.id
                                })
                                //ON SUCCESS
                                .then(function (response) {
                                    $('body').LoadingOverlay("hide");
                                    $.each(activeInstance.projects_client_approved, function (index, project) {
                                        if (record.id == project.id) {
                                            project.phase = 'completed';
                                        }
                                    });
                                    activeInstance.getAcceptedClosures();
                                    activeInstance.getPendingClosures();
                                })

                                //ON ERROR
                                .catch(function (error, response) {
                                    $('body').LoadingOverlay("hide");

                                    if (error.response.data.status == 'unclosed_tickets_present') {
                                        bootbox.alert("A projektet még nem lehet lezárni, mert nyitott ticketet tartalmaz.");
                                    } else {
                                        console.log(error);
                                    }
                                });
                            }

                            return true;

                        }
                        else{
                            return true;
                        }

                    });
                    break;
            }

            console.log("record");

        },
        showTicketTransferDialog: function (project) {
            vex.dialog.open({
                input: [
                    /* TITLE */
                    '<div style="margin-bottom:20px;color:#3aaad8;font-weight:bold;">Ahhoz, hogy a projektet zárni tudjuk, át kell hogy mozgassuk a nem zárható ticketeket ennek a projektnek egy másolatába.</div>',

                    /* PROJECT NAME */
                    '<label style="margin-top:10px;">Az új projekt neve</label>',
                    '<input style="width:100%;display:block;" name="name" type="text" value="' + project.name + ' (másolat)" placeholder="Az új projekt neve" required />',

                    /* DEADLINE */
                    '<fieldset style="margin-top:20px;margin-bottom: 0px;" class="form-group no_padding">',
                    '<label>Ügyfél leadás határideje</label>',
                    '<div class=\'input-group date\' id=\'datetimepicker6\'>',
                    '<input required name="deadline" type=\'text\' class="form-control-vex disabled" id="deadline" v-model=\'deadline\'/>',
                    '<span class="input-group-addon">',
                    '<span class="glyphicon glyphicon-calendar"></span>',
                    '</span>',
                    '</div>',
                    '</fieldset>',

                    /* DATE OF COMPLETION */
                    '<label style="margin-top:20px;">Teljesítés hónapja</label>',
                    '<select name="completion_month" style="margin-bottom:30px;" id="completion_month" required  class="form-control-vex">',
                    '<option value="01">Január</option>',
                    '<option value="02">Február</option>',
                    '<option value="03">Március</option>',
                    '<option value="04">Április</option>',
                    '<option value="05">Május</option>',
                    '<option value="06">Június</option>',
                    '<option value="07">Július</option>',
                    '<option value="08">Augusztus</option>',
                    '<option value="09">Szeptember</option>',
                    '<option value="10">Október</option>',
                    '<option value="11">November</option>',
                    '<option value="12">December</option>',
                    '</select>',
                    ' '
                ].join(''),
                buttons: [
                    $.extend({}, vex.dialog.buttons.YES, {text: 'Rendben'}),
                    $.extend({}, vex.dialog.buttons.NO, {text: 'Mégse'})
                ],
                afterOpen: function () {
                    setTimeout(function () {
                        $('#datetimepicker6').datetimepicker({
                            format: 'YYYY-MM-DD HH:00',
                            locale: 'hu'
                        });
                    }, 300);

                },
                callback: function (data) {
                    if (!data) {
                        console.log('Cancelled')
                    }
                    else {
                        axios.post(baseURL + '/api/project/clone', {
                            'old_project_id': project.id,
                            'name': data.name,
                            'deadline': data.deadline,
                            'completion_month': data.completion_month
                        })
                    }
                }
            });
        },
        check: function () {
            vex.dialog.confirm({
                message: 'Biztosan visszavonod?',
                callback: function (data) {
                    if (!data) {
                        console.log('Cancelled')
                    } else {
                        axios.post(baseURL + '/api/traffic/task/cancel', {
                            'task_id': task.id
                        })
                            .then(function (response) {

                                task = response.data.updated_data;

                            });

                        //TODO::UPDATE THE TASK ACCORDING TO THE SERVER RESPONSE (SHOULD BE VISIBLE IN THE CALENDAR AFTER THIS)


                    }
                }
            });
        },
        closeTicket: function (record) {
            console.log(record);
            bootbox.confirm('Biztosan lezárod a(z) ' + record.name + ' ticketet?', function (value) {
                if (value == true) {
                    /////////////66
                    if (record.invoice_required) {
                        vex.dialog.open({
                            input: [
                                /* PROJECT NAME */
                                '<h2 style="margin-top:10px;">A(z) ' + record.name + ' ticket zárása</h2>',
                                '<label style="margin-top:10px;">Kérjük add meg a kimenő számla sorszámát:</label>',
                                '<input style="width:100%;display:block;" name="outgoing_invoice_number" type="text" placeholder="A kimenő számla sorszáma" required />',

                                ' '
                            ].join(''),
                            buttons: [
                                $.extend({}, vex.dialog.buttons.YES, {text: 'Rendben'}),
                                $.extend({}, vex.dialog.buttons.NO, {text: 'Mégse'})
                            ],
                            afterOpen: function () {

                            },
                            callback: function (data) {
                                if (!data) {
                                    console.log('Cancelled');
                                    return true;
                                }
                                else {

                                    showLoadingOverlay();
                                    axios.post(baseURL + '/admin/project/ticket/financially_close', {
                                        'ticket_id': record.id,
                                        'outgoing_invoice_number': data.outgoing_invoice_number
                                    })
                                        .then(function (response) {
                                            $.each(activeInstance.projects_client_approved, function (index, project) {
                                                if (record.project_id == project.id) {
                                                    $.each(project.tickets, function (index, ticket) {
                                                        if (record.id == ticket.id) {
                                                            ticket.phase = 'completed';
                                                        }
                                                    });
                                                }
                                            });
                                            activeInstance.getPendingClosures();
                                            activeInstance.getAcceptedClosures();
                                            record.phase = 'completed';
                                            //activeInstance.$set(record, 'phase', 'completed');
                                            $('body').LoadingOverlay("hide");
                                        })

                                        .catch(function (error) {
                                            console.log(error);
                                        });

                                }
                            }
                        });
                    }
                    else {
                        axios.post(baseURL + '/admin/project/ticket/financially_close', {
                            'ticket_id': record.id,
                            'outgoing_invoice_number': null
                        })
                            .then(function (response) {
                                $.each(activeInstance.projects_client_approved, function (index, project) {
                                    if (record.project_id == project.id) {
                                        $.each(project.tickets, function (index, ticket) {
                                            if (record.id == ticket.id) {
                                                ticket.phase = 'completed';
                                            }
                                        });
                                    }
                                });
                                activeInstance.getPendingClosures();
                                activeInstance.getAcceptedClosures();
                                record.phase = 'completed';
                                //activeInstance.$set(record, 'phase', 'completed');
                                $('body').LoadingOverlay("hide");
                            })

                            .catch(function (error) {
                                console.log(error);
                            });
                    }
                    ///////////////////////

                }
            });
        },
        openProject: function (record) {
            bootbox.confirm('Biztosan megnyitod a ' + record.name + ' projektet?', function (value) {
                if (value == true) {

                    $('body').LoadingOverlay("show");
                    axios.post(baseURL + '/admin/project/open', {
                        project_id: record.id
                    })
                        .then(function (response) {
                            $('body').LoadingOverlay("hide");
                            record.phase = 'active';
                        })
                        .catch(function (error) {
                            $('body').LoadingOverlay("hide");
                            console.log(error);
                        });
                }
            });
        },
        openTicket: function (record) {
            bootbox.confirm('Biztosan megnyitod a ' + record.name + ' ticketet?', function (value) {
                if (value == true) {

                    $('body').LoadingOverlay("show");
                    axios.post(baseURL + '/admin/project/ticket/open', {
                        ticket_id: record.id
                    })
                        .then(function (response) {
                            $('body').LoadingOverlay("hide");

                            /*
                            $.each(activeInstance.projects,function(index,project){
                                if (record.project_id == project.id) {
                                    $.each(project.tickets,function(index,ticket){
                                        if (record.id == ticket.id) {
                                            ticket.phase = 'completed';
                                        }
                                    });
                                }
                            });
                            */
                            record.phase = 'active';

                            activeInstance.getAcceptedClosures();
                        })
                        .catch(function (error) {
                            $('body').LoadingOverlay("hide");
                            console.log(error);
                        });
                }
            });
        },

    }
});